import { React, Component, _ } from 'utils';
import { Creators } from 'model';
import './qualifications.less';

export default class QualificationFilter extends Component {

	handleToggle() {
		Creators.toggleFilter({
			filterName: this.props.filterName,
			data: this.props.model 
		});
	}

	render() {
		const { model } = this.props;

		const cls = ['col-md-6'];

		if(model.selected) {
			cls.push('selected')
		}

		return (
			<div className={ cls.join(' ') }>
				<div className="box" onClick={() => this.handleToggle()}>
					<i className="fa fa-check-circle" />
					<div className="name">{_(model.name)}</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/app/filters/QualificationFilter.js